export const TENANT = 'uk'
export const ENVIRONMENT = 'production'
export const TEAM = 'production'
export const IS_PRODUCTION = true

export const IS_TOP_RANK_ENABLED = false
export const IS_PRODUCT_TOURS_ENABLED = false
